import { initBaseInstance } from '../shared/utils/sentryManager';

initBaseInstance({
  dsn: process.env.MED_SENTRY_DSN!,
});
